import { MotifCheckbox } from '@ey-xd/motif-react';
import React from 'react'

const ApprovalQuestionOption = (props: any) => {
    const {optionNumber, content, selected} = props;
  return (
    <div className="bg-[#23232F] border-b border-[#4E4E5D]">
        <span className="px-2 py-1 text-xs bg-[#4E4E5D] text-[#fff]">
            {optionNumber}
        </span>
        <div className="mt-1 p-3 flex gap-2 items-start">
        <MotifCheckbox
        checked = {selected}
            > </MotifCheckbox>
            <div className="text-sm text-[#9897A6]">
              {content}
            </div>
        </div>
    </div>
  )
}

export default ApprovalQuestionOption